import React, { useEffect, useState } from "react";
import { Row, Col, Button as Btn } from "react-bootstrap";
import Badge from "react-bootstrap/Badge";
import styled from "styled-components";
import jwtInterceptor from "../../components/shared/jwtInterceptor";
import LanguageFlags from "../../components/LanguageFlags";
import ModalPDF from "../../components/ModalPDF";
import { useTranslation } from "react-i18next";
import api_keys from "../../utils/constants/api_keys.json";
import { toast } from "react-toastify";
import TreeList, {
  Column,
  Selection,
  Scrolling,
  Editing,
  Button,
} from "devextreme-react/tree-list";
// import "devextreme/dist/css/dx.light.css";
import "whatwg-fetch";
import {
  loggedUser,
  isUserAdmin,
  isUserEditor,
} from "../../utils/functions/functionsUtils";
import { Popup, ToolbarItem as ToolbarPopup } from "devextreme-react/popup";
import { LoadPanel } from "devextreme-react/load-panel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  DataGrid,
  Column as ColumnDataGrid,
  Paging as PagingDataGrid,
  SearchPanel as SearchPanelDataGrid,
  Selection as SelectionDataGrid,
  HeaderFilter as HeaderFilterDataGrid,
} from "devextreme-react/data-grid";
import ReactFlagsSelect from "react-flags-select";
import { useNavigate } from "react-router-dom";
import { Form, GroupItem, Item, Label } from "devextreme-react/form";
import { Category } from "../../models/category";

const TreeListContainer = styled.div`
  width: 100%;
  padding: 20px 10px 20px 0px;
  word-wrap: break-word;
`;

const CategoryImage = styled.img`
  padding: 5px;
  height: 40px;
  filter: invert(1) !important;
`;

const DivCategory = styled.div<{ color: string }>`
  background-color: ${(prop) => prop.color};
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
`;

const DivCategoryPopup = styled.div<{ color: string }>`
  background-color: ${(prop) => prop.color};
  border-radius: 4px;
  margin-bottom: 20px;
`;

const SpanCategory = styled.span`
  padding: 10px;
  font-size: 20px;
  color: white;
`;

const ButtonText = styled.span`
  padding-left: 5px;
`;

const ButtonsContainer = styled.div`
  padding-left: 10px;
  display: flex;
  justify-content: space-around;
`;

const ButtonFavorite = styled.button<{ color: string }>`
  background-color: ${(prop) => prop.color};
  font-size: 1em;
  margin: 5px 10px;
  padding: 0.25em 1em;
  border: 2px solid #fff;
  border-radius: 3px;
  &:hover {
    box-shadow: 5px 5px 5px light-gray;
    transform: scale(1.1);
  }
`;

const LangSelector = styled(ReactFlagsSelect)`
  padding-right: 5px;
`;

const DivMultiLanguage = styled.div``;

const VersionsText = styled.span`
  color: rgb(20, 27, 77);
  font-size: large;
`;

const DivMultiLanguageInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonMultiLanguage = styled.button`
  font-size: 1em;
  margin: 5px 10px;
  padding: 0.25em 1em;
  border: 2px solid rgb(20, 27, 77) !important;
  border-radius: 4px !important;
  align-items: center !important;
  background-color: rgb(20, 27, 77) !important;
  display: flex !important;
  &:hover {
    box-shadow: 5px 5px 5px light-gray;
    transform: scale(1.1);
  }
`;

const ButtonPopupFavorite = styled.button`
  font-size: 1em;
  margin: 5px 10px;
  padding: 0.25em 1em;
  border: 2px solid rgb(13, 110, 253) !important;
  border-radius: 4px !important;
  align-items: center !important;
  background-color: rgb(13, 110, 253) !important;
  display: flex !important;
  &:hover {
    box-shadow: 5px 5px 5px light-gray;
    transform: scale(1.1);
  }
`;

const ButtonPopupUnFavorite = styled.button`
  font-size: 1em;
  margin: 5px 10px;
  padding: 0.25em 1em;
  border: 2px solid rgb(13, 110, 253) !important;
  border-radius: 4px !important;
  align-items: center !important;
  background-color: rgb(13, 110, 253) !important;
  display: flex !important;
  &:hover {
    box-shadow: 5px 5px 5px light-gray;
    transform: scale(1.1);
  }
`;

const ButtonPopupLink = styled.button`
  font-size: 1em;
  margin: 5px 10px;
  padding: 0.25em 1em;
  border: 2px solid rgb(73, 191, 189) !important;
  border-radius: 4px !important;
  align-items: center !important;
  background-color: rgb(73, 191, 189);!important;
  display: flex !important;
  &:hover {
    box-shadow: 5px 5px 5px light-gray;
    transform: scale(1.1);
  }
`;

const DivInnerHeaderCells = styled.div`
  display: flex;
  justify-content: flex-start;
`;

function GlobalSearchTreeList() {
  //States declaration
  const [selectedCategory] = useState<any>({} as any);
  const [categoryDocumentData, setCategoryDocumentData] = useState<any[]>([]);
  const [selectedDocument, setSelectedDocument] = useState<any>({} as any);
  const [parameters] = useState<any[]>([]);
  const [HTMLDocumentPopupVisible, setHTMLDocumentPopupVisible] =
    useState(false);
  const [popupSummaryVisible, setPopupSummaryVisible] = useState(false);
  const [loadingTreeList, setLoadingTreeList] = useState(false);
  const [allDocumentsView, setAllDocumentsView] = useState(true);
  const [favoritesCount, setFavoritesCount] = useState(0);
  const [allDocumentsCount, setAllDocuments] = useState(0);
  const [documentSummaries, setDocumentSummaries] = useState<any[]>([]);
  const [savedSummaries, setSavedSummaries] = useState([]);
  const [savedCategories, setSavedCategories] = useState([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [summaries, setSummaries] = useState([]);
  const [selectedSummaries, setSelectedSummaries] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [multiLanguagePopupVisible, setMultiLanguagePopupVisible] =
    useState(false);
  const [selectedDocumentRevisionId, setSelectedDocumentRevisionId] =
    useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popupFilterSummaryVisible, setPopupFilterSummaryVisible] =
    useState(false);
  const [popupFilterCategoryVisible, setPopupFilterCategoryVisible] =
    useState(false);
  const [searchGlobalKeyword, setSearchGlobalKeyword] = useState([""]);
  const activeTheme = window.localStorage["themeViewer"] || "light";
  const [_theme, setTheme] = useState(activeTheme);

  //Translation module
  const { t } = useTranslation();
  //*******************
  let navigate = useNavigate();
  let summaryDataGrid: any;
  let categoryDataGrid: any;

  const isDarkMode = () => {
    return _theme === "dark";
  };

  //Functions
  const isVisible = (keyValue: string) => {
    let tempCat = parameters.filter(function (ft) {
      return ft.name.includes(keyValue);
    });
    return tempCat.length > 0;
  };

  const handleSetDocAsFav = (e: any) => {
    if (!e.row.data) return;
    const payload = {
      UserId: loggedUser().id,
      DocumentRevisionId: e.row.data.documentRevisionId,
      IsSettingFavorite: e.row.data.isSettingFavorite === 1 ? 0 : 1,
    };
    favoriteDocument(payload);
  };

  const showNotifications = (
    data: any,
    showOnSuccess: boolean,
    message: string
  ) => {
    //Notifications
    if (data.statusCode === 200) {
      if (showOnSuccess)
        toast.success(t(message), {
          position: "top-right",
        });
    } else {
      toast.error(data.message, { position: "top-right" });
    }
  };

  const onFocusedRowChanged = (e: any) => {
    if (e.row === undefined) return;
    setSelectedDocument(e.row.data);
    setSelectedDocumentRevisionId(e.row.data.documentRevisionId);
  };

  const onTreeListCellClick = (e: any) => {
    if (e.data === undefined) return;
    handleSeeDocumentClick(e);

    if (e.component) {
      //span means the user clicked on the expand/collapse icon
      if (e.event.target.tagName.toLowerCase() !== "span") {
        if (e.row && e.row.isExpanded) {
          e.component.collapseRow(e.key);
        }
        if (e.row && !e.row.isExpanded) {
          e.component.expandRow(e.key);
        }
      }
    }
  };

  const hideFilterSummaryPopup = () => {
    setPopupFilterSummaryVisible(false);
  };

  const hideFilterCategoryPopup = () => {
    setPopupFilterCategoryVisible(false);
  };

  const showFilterSummaryPopup = () => {
    setSelectedRows();
    setPopupFilterSummaryVisible(true);
  };

  const showFilterCategoryPopup = () => {
    setSelectedCategoryRows();
    setPopupFilterCategoryVisible(true);
  };

  const getFrontGlobalSearchFiles = (
    seeFavorite: number,
    isClearSearch: boolean
  ) => {
    setLoadingTreeList(true);
    let searchContent = isClearSearch ? [""] : searchGlobalKeyword;
    let payloadGlobalSearch = {
      summaries: selectedSummaries,
      categories: selectedCategories,
    };

    return jwtInterceptor
      .post(
        `${api_keys.apiManagement_URL}${api_keys.apiManagementAPIName_URL}${
          api_keys.getFrontGlobalSearchFiles
        }?userId=${loggedUser().id}&userLanguage=${
          loggedUser().language
        }&seeFavorite=${seeFavorite}&searchWord=${searchContent}`,
        payloadGlobalSearch
      )
      .then((response) => {
        if (response) {
          setCategoryDocumentData(response.data.payload.data);
          setFavoritesCount(response.data.payload.totalFavorites);
          setAllDocuments(response.data.payload.totalCount);
          setLoadingTreeList(false);

          if (selectedDocument) {
            let filterDocument = response.data.payload.data.filter(
              (x: any) => x.documentRevisionId === selectedDocumentRevisionId
            );
            if (filterDocument.length) setSelectedDocument(filterDocument[0]);
          }
          return response.data.payload.data;
        }
      })
      .finally(() => {
        setLoadingTreeList(false);
      });
  };

  const isSettingFavoriteOptionVisible = (e: any) => {
    return (
      (e.row.data.blobFilePath ||
        e.row.data.isHtml ||
        e.row.data.blobSecondFileName) &&
      e.row.data.isSettingFavorite === 0
    );
  };

  const isSettingUnfavoriteOptionVisible = (e: any) => {
    return (
      (e.row.data.blobFilePath ||
        e.row.data.isHtml ||
        e.row.data.blobSecondFileName) &&
      e.row.data.isSettingFavorite === 1
    );
  };

  const getSummaries = () => {
    return jwtInterceptor
      .get(
        `${api_keys.apiManagement_URL}${api_keys.apiManagementAPIName_URL}${api_keys.getSummaries}`
      )
      .then((response) => {
        setSummaries(response.data.payload);
      });
  };

  const getCategories = () => {
    return jwtInterceptor
      .get(
        `${api_keys.apiManagement_URL}${api_keys.apiManagementAPIName_URL}${api_keys.getCategories}`
      )
      .then((response) => {
        const result = response.data.payload.filter(
          (rest: Category) => rest.color !== ""
        );
        setCategories(result);
      });
  };

  useEffect(() => {
    getFrontGlobalSearchFiles(0, false);
    getSummaries();
    getCategories();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDocumentsBySummaryId = (summaryId: number) => {
    setLoadingTreeList(true);
    return jwtInterceptor
      .get(
        `${api_keys.apiManagement_URL}${api_keys.apiManagementAPIName_URL}${api_keys.getDocumentsBySummaryId}?summaryId=${summaryId}`
      )
      .then((response) => {
        setDocumentSummaries(response.data.payload);
        showSummaryPopup();
        setLoadingTreeList(false);

        return response.data.payload;
      })
      .finally(() => {
        setLoadingTreeList(false);
      });
  };

  const handleSeeDocumentClick = (e: any) => {
    var documentIsHtml = e.data.isHtml === 1 && e.data.htmlContent !== "";
    if (documentIsHtml) {
      showHTMLPopup();
    } else if (e.data.categoryDocumentId > 0) {
      showPDFPopup();
    }
  };

  const handlePopupArticleLinkClick = (e: any) => {
    window.open(selectedDocument.articleLink, "_blank", "noreferrer");
  };

  const showHTMLPopup = () => {
    setHTMLDocumentPopupVisible(true);
  };

  const closeHTMLPopup = () => {
    setHTMLDocumentPopupVisible(false);
  };

  const hideSummaryPopup = () => {
    setPopupSummaryVisible(false);
  };

  const hideMultiLanguagePopup = () => {
    setMultiLanguagePopupVisible(false);
  };

  const showSummaryPopup = () => {
    setPopupSummaryVisible(true);
  };

  const onSummarySelectionChanged = ({ selectedRowsData }: any) => {
    setSelectedSummaries(selectedRowsData);
  };

  const onCategorySelectionChanged = ({ selectedRowsData }: any) => {
    setSelectedCategories(selectedRowsData);
  };

  const closeHTMLPopupButtonOptions = {
    onClick: closeHTMLPopup,
    text: "Close",
    icon: "close",
    type: "danger",
    elementAttr: {
      class: "see-document-button",
    },
  };

  const closeSummaryPopupButtonOptions = {
    onClick: hideSummaryPopup,
    text: t("PopupClose"),
    icon: "close",
    type: "danger",
    elementAttr: {
      class: "see-document-button",
    },
  };

  const closeMultiLanguagePopupButtonOptions = {
    onClick: hideMultiLanguagePopup,
    text: t("PopupClose"),
    icon: "close",
    type: "danger",
    elementAttr: {
      class: "see-document-button",
    },
  };

  const closeSummaryPopupFilterButtonOptions = {
    onClick: hideFilterSummaryPopup,
    text: t("PopupClose"),
    icon: "close",
    type: "danger",
    elementAttr: {
      class: "see-document-button",
    },
  };

  const closeCategoryPopupFilterButtonOptions = {
    onClick: hideFilterCategoryPopup,
    text: t("PopupClose"),
    icon: "close",
    type: "danger",
    elementAttr: {
      class: "see-document-button",
    },
  };

  const saveFilterSummarySelection = () => {
    setSavedSummaries(selectedSummaries);
    hideFilterSummaryPopup();
    let opt = allDocumentsView ? 0 : 1;
    getFrontGlobalSearchFiles(opt, false);
  };

  const saveFilterCategorySelection = () => {
    setSavedCategories(selectedCategories);
    hideFilterCategoryPopup();
    let opt = allDocumentsView ? 0 : 1;
    getFrontGlobalSearchFiles(opt, false);
  };

  const clearSelection = () => {
    summaryDataGrid.instance.clearSelection();
  };

  const clearCategorySelection = () => {
    categoryDataGrid.instance.clearSelection();
  };

  const buttonSummaryClearAttributes = {
    id: "summaryClearButton",
  };

  const buttonCategoryClearAttributes = {
    id: "summaryClearButton",
  };

  const clearSelectionOptions = {
    text: t("PopupCategoriesSummaryClearSelection"),
    icon: "clearformat",
    type: "default",
    disabled: selectedSummaries.length <= 0,
    elementAttr: buttonSummaryClearAttributes,
    onClick: clearSelection,
  };

  const clearCategorySelectionOptions = {
    text: t("PopupCategoriesSummaryClearSelection"),
    icon: "clearformat",
    type: "default",
    disabled: selectedCategories.length <= 0,
    elementAttr: buttonCategoryClearAttributes,
    onClick: clearCategorySelection,
  };

  const saveSummaryPopupFilterButtonOptions = {
    text: t("PopupFilter"),
    icon: "search",
    elementAttr: {
      class: "see-document-button",
    },
    type: "success",
    onClick: saveFilterSummarySelection,
  };

  const saveCategoryPopupFilterButtonOptions = {
    text: t("PopupFilter"),
    icon: "search",
    elementAttr: {
      class: "see-document-button",
    },
    type: "success",
    onClick: saveFilterCategorySelection,
  };

  const setSelectedRows = () => {
    summaryDataGrid.instance.selectRows(savedSummaries, true);
  };

  const setSelectedCategoryRows = () => {
    categoryDataGrid.instance.selectRows(savedCategories, true);
  };

  const searchDocuments = (isClearSearch: boolean) => {
    let opt = allDocumentsView ? 0 : 1;
    getFrontGlobalSearchFiles(opt, isClearSearch);
  };

  const clearSearchOption = () => {
    setSearchGlobalKeyword([""]);
    searchDocuments(true);
  };

  const handleSearchChange = (e: any) => {
    const searchText: string[] = [e.value];
    setSearchGlobalKeyword(searchText);
  };

  const handleSearchButtonClick = () => {
    searchDocuments(false);
  };

  const onToolbarPreparing = (e: any) => {
    e.toolbarOptions.items.unshift(
      {
        location: "after",
        locateInMenu: "auto",
        widget: "dxButton",
        options: {
          icon: "checklist",
          type: "default",
          elementAttr: {
            id: "summaryButton",
            class: "button-summary",
          },
          text: `${t("FilterBy")} ${t("PopupCategoriesSummary")} (${
            savedSummaries.length
          }) `,
          disabled: false,
          onClick: showFilterSummaryPopup,
        },
      },
      {
        location: "after",
        locateInMenu: "auto",
        widget: "dxButton",
        options: {
          icon: "checklist",
          type: "default",
          elementAttr: {
            id: "summaryButton",
            class: "button-summary",
          },
          text: `${t("FilterBy")} ${t("PopupCategoryCategory")} (${
            savedCategories.length
          }) `,
          disabled: false,
          onClick: showFilterCategoryPopup,
        },
      },
      {
        location: "after",
        locateInMenu: "auto",
        widget: "dxButton",
        options: {
          icon: "clearformat",
          type: "default",
          elementAttr: {
            id: "clearResults",
            class: "see-document-button",
          },
          text: t("ClearSearch"),
          disabled:
            !searchGlobalKeyword.length || searchGlobalKeyword[0] === "",
          onClick: clearSearchOption,
        },
      },
      {
        location: "after",
        locateInMenu: "auto",
        widget: "dxTextBox",
        options: {
          icon: "find",
          width: 240,
          value: searchGlobalKeyword,
          onValueChanged: handleSearchChange,
          placeholder: t("Search"),
        },
      },
      {
        location: "after",
        locateInMenu: "auto",
        widget: "dxButton",
        options: {
          icon: "find",
          type: "success",
          elementAttr: {
            id: "searchDocuments",
            class: "see-document-button",
          },
          text: t("BtnSearch"),
          disabled:
            !searchGlobalKeyword.length || searchGlobalKeyword[0] === "",
          onClick: handleSearchButtonClick,
        },
      }
    );
  };

  const treeListContentReady = (e: any) => {
    if (e.component) {
      e.component.forEachNode(function (node: any) {
        //painting main categories row
        if (node.data && node.data.categoryId === 999999) {
          e.component.expandRow(node.key);
        }

        if (node.data && node.data.parentId && node.data.parentId === 999999) {
          let row = e.component.getRowIndexByKey(node.key);
          let rowElement = e.component.getRowElement(row);
          if (rowElement.length) {
            rowElement[0].style.backgroundColor = !isDarkMode()
              ? "lightgray"
              : "#29a6b3";
          }
        }
      });
    }
  };

  const openSumaryPopup = (rowData: any) => {
    getDocumentsBySummaryId(rowData.id);
    return;
  };

  const SummaryButtons = (rowdata: any) => {
    return rowdata.data &&
      rowdata.data.data &&
      rowdata.data.data.summaries &&
      rowdata.data.data.summaries.length
      ? rowdata.data.data.summaries.map((a: any) => (
          <Btn
            variant="secondary"
            className="badge"
            style={{
              marginRight: "5px",
              color: "black",
              backgroundColor: "white",
            }}
            onClick={() => openSumaryPopup(a)}
          >
            {a.name}
          </Btn>
        ))
      : "";
  };

  const SearchSpan = (rowdata: any) => {
    return <VersionsText>{searchGlobalKeyword}</VersionsText>;
  };

  const onDownloadFile = async (e: any) => {
    return downloadFile(e.row.data.blobSecondFileName);
  };

  const downloadFile = async (fileName: string) => {
    return jwtInterceptor
      .get(
        `${api_keys.apiManagement_URL}${api_keys.apiManagementAPIName_URL}${api_keys.downloadCategoryFile}?fileName=${fileName}&categoryCode=${selectedCategory.CategoryName} `,
        { responseType: "blob" }
      )
      .then((response: any) => {
        var url = window.URL.createObjectURL(response.data);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };

  const isDownloadOptionVisible = (e: any) => {
    return (
      e.row.data.blobSecondFileName !== null &&
      e.row.data.blobSecondFileName !== "" &&
      e.row.data.categoryCode === "models"
    );
  };

  const onSelectLanguage = (code: string): void => {
    //do nothing, only because its mandatory
    return;
  };

  const onClickFlagButton = (a: any) => {
    setSelectedDocumentRevisionId(a.documentRevisionId);
    setIsModalOpen(true);
  };

  const showPDFPopup = () => {
    setMultiLanguagePopupVisible(true);
  };

  const onRedirectToCategoryDetails = async (e: any) => {
    navigate(
      `/categoryDetails/${selectedCategory.CategoryName}/${e.row.data.categoryDocumentId}`
    );
    return false;
  };

  const isRedirectOptionVisible = (e: any) => {
    return (
      e.row.data.categoryDocumentId > 0 && (isUserAdmin() || isUserEditor())
    );
  };

  const resumeOptions = {
    height: 180,
    readOnly: true,
  };

  const nameHeaderFilterDataSource = [
    {
      text: "A",
      value: ["name", "startswith", "A"],
    },
    {
      text: "B",
      value: ["name", "startswith", "B"],
    },
    {
      text: "C",
      value: ["name", "startswith", "C"],
    },
    {
      text: "D",
      value: ["name", "startswith", "D"],
    },
    {
      text: "E",
      value: ["name", "startswith", "E"],
    },
    {
      text: "F",
      value: ["name", "startswith", "F"],
    },
    {
      text: "G",
      value: ["name", "startswith", "G"],
    },
    {
      text: "H",
      value: ["name", "startswith", "H"],
    },
    {
      text: "I",
      value: ["name", "startswith", "I"],
    },
    {
      text: "J",
      value: ["name", "startswith", "J"],
    },
    {
      text: "K",
      value: ["name", "startswith", "K"],
    },
    {
      text: "L",
      value: ["name", "startswith", "L"],
    },
    {
      text: "M",
      value: ["name", "startswith", "M"],
    },
    {
      text: "N",
      value: ["name", "startswith", "N"],
    },
    {
      text: "O",
      value: ["name", "startswith", "O"],
    },
    {
      text: "P",
      value: ["name", "startswith", "P"],
    },
    {
      text: "Q",
      value: ["name", "startswith", "Q"],
    },
    {
      text: "R",
      value: ["name", "startswith", "R"],
    },
    {
      text: "S",
      value: ["name", "startswith", "S"],
    },
    {
      text: "T",
      value: ["name", "startswith", "T"],
    },
    {
      text: "U",
      value: ["name", "startswith", "U"],
    },
    {
      text: "V",
      value: ["name", "startswith", "V"],
    },
    {
      text: "W",
      value: ["name", "startswith", "W"],
    },
    {
      text: "X",
      value: ["name", "startswith", "X"],
    },
    {
      text: "Y",
      value: ["name", "startswith", "Y"],
    },
    {
      text: "Z",
      value: ["name", "startswith", "Z"],
    },
  ];

  const onRedirectToExternalLink = async (e: any) => {
    window.open(e.row.data.articleLink, "_blank");
    return false;
  };

  const isRedirectToExternalLinkVisible = (e: any) => {
    return e.row.data.articleLink;
  };

  const isPopupLinkToArticleOptionVisible = () => {
    return (
      selectedDocument.categoryDocumentId > 0 &&
      selectedDocument.isHtml &&
      selectedDocument.isHtml === 1 &&
      selectedDocument.articleLink !== "" &&
      selectedDocument.articleLink
    );
  };

  const favoriteDocument = (apiData: any) => {
    return jwtInterceptor
      .post(
        `${api_keys.apiManagement_URL}${api_keys.apiManagementAPIName_URL}${api_keys.setDocumentAsFavorite}`,
        apiData
      )
      .then((response) => {
        showNotifications(response.data, true, "DocumentFavorite");
        getFrontGlobalSearchFiles(0, false);
      });
  };

  const popupDocumentHandleFavorite = () => {
    const payload = {
      UserId: loggedUser().id,
      DocumentRevisionId: selectedDocument.documentRevisionId,
      IsSettingFavorite: selectedDocument.isSettingFavorite === 1 ? 0 : 1,
    };
    favoriteDocument(payload);
  };

  const summaryPopupRowChanged = (e: any) => {
    if (e.data === undefined) {
      return;
    }
    setSelectedDocument(e.data);
    setSelectedDocumentRevisionId(e.data.documentRevisionId);
    showPDFPopup();
  };

  const seeFavorite = () => {
    let opt = allDocumentsView ? 1 : 0;
    getFrontGlobalSearchFiles(opt, false);
    setAllDocumentsView(!allDocumentsView);
  };

  const headerCellWithOrderIcon = (caption: any) => {
    return (
      <DivInnerHeaderCells>
        <span>
          <FontAwesomeIcon icon={["fas", "sort"]} /> {caption}
        </span>
      </DivInnerHeaderCells>
    );
  };

  const isTherePdfDocument = (multiLanguages: any) => {
    var thereIsPdf =
      multiLanguages &&
      multiLanguages.filter((x: any) => x.hasPdfDocument === 1).length > 0;
    return thereIsPdf;
  };

  const popupRedirectToExternalLink = (link: string) => {
    window.open(link, "_blank");
    return false;
  };

  return (
    <TreeListContainer>
      <Row>
        <Col>
          <DivCategory color={"#141b4d"}>
            <div>
              <CategoryImage
                src={
                  "data:image/svg+xml;base64,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"
                }
              />
              <SpanCategory color={selectedCategory.color}>
                {t("AllCategoryDocuments")}
              </SpanCategory>
              <SpanCategory color={selectedCategory.color}>
                {"| " + t("TotalFiles") + ": " + allDocumentsCount}
              </SpanCategory>
            </div>
            <ButtonsContainer>
              <ButtonFavorite color={"#141b4d"} onClick={seeFavorite}>
                <FontAwesomeIcon icon={["fas", "star"]} />
                <ButtonText>
                  {allDocumentsView
                    ? t("SeeFavoriteButton") + ` (${favoritesCount})`
                    : t("SeeAllButton") + ` (${allDocumentsCount})`}
                </ButtonText>
              </ButtonFavorite>
            </ButtonsContainer>
          </DivCategory>
        </Col>
      </Row>
      <Row>
        <LoadPanel
          visible={loadingTreeList}
          showIndicator={true}
          shading={true}
          shadingColor="rgba(0,0,0,0.4)"
          showPane={false}
          message={t("LoadingCategoryFiles")!}
        />
        <Col>
          <TreeList
            id="TreelistAllCategoryDocuments"
            dataSource={categoryDocumentData}
            keyExpr="categoryId"
            parentIdExpr="parentId"
            showRowLines={true}
            showBorders={true}
            focusedRowEnabled={true}
            autoExpandAll={false}
            columnAutoWidth={true}
            showColumnLines={false}
            showColumnHeaders={true}
            allowColumnReordering={true}
            onToolbarPreparing={onToolbarPreparing}
            onFocusedRowChanged={onFocusedRowChanged}
            onCellClick={onTreeListCellClick}
            onContentReady={treeListContentReady}
            noDataText={t("NoDataCategoryFiles")!}
          >
            <Selection mode="single" />
            <Scrolling mode="standard" />
            <Editing
              allowAdding={false}
              allowDeleting={false}
              allowUpdating={false}
            />
            <Column
              dataField="categoryName"
              caption={t("CategoryName")!}
              visible={true}
              headerCellRender={() =>
                headerCellWithOrderIcon(t("CategoryName")!)
              }
              allowEditing={false}
            />
            <Column
              dataField="summary"
              caption={t("Summary")!}
              visible={true}
              allowSorting={false}
              cellRender={(data) => <SummaryButtons data={data} />}
              alignment={"left"}
              allowEditing={false}
            />

            <Column
              dataField="categoryId"
              visible={false}
              width={100}
              allowEditing={false}
            />
            <Column
              dataField="parentId"
              visible={false}
              width={10}
              allowEditing={false}
            />

            <Column
              dataField="jurisdiction"
              caption={t("PopupCategoriesJurisdiction")!}
              visible={false}
              alignment={"left"}
              allowEditing={false}
            />
            <Column
              dataField="resume"
              caption={t("PopupCategoriesResume")!}
              visible={false}
              width={400}
              allowEditing={false}
            />
            <Column
              dataField="reference"
              caption={t("PopupCategoriesReference")!}
              headerCellRender={() =>
                headerCellWithOrderIcon(t("PopupCategoriesReference")!)
              }
              visible={true}
              alignment={"left"}
              allowEditing={false}
            />
            <Column
              dataField="status"
              caption={t("PopupCategoriesStatus")!}
              headerCellRender={() =>
                headerCellWithOrderIcon(t("PopupCategoriesStatus")!)
              }
              visible={isVisible("Status")}
              alignment={"center"}
              allowEditing={false}
            />
            <Column
              dataField="number"
              caption={t("PopupCategoriesRevisionNumber")!}
              visible={false}
              alignment={"left"}
              allowEditing={false}
            />
            <Column
              dataField="language"
              caption={t("Language")!}
              visible={false}
              alignment={"center"}
              allowEditing={false}
            />
            <Column
              dataField="publicationTitle"
              caption={t("PopupCategoriesPublicationTitle")!}
              headerCellRender={() =>
                headerCellWithOrderIcon(t("PopupCategoriesPublicationTitle")!)
              }
              visible={isVisible("PublicationTitle")}
              alignment={"left"}
              allowEditing={false}
            />
            <Column
              dataField="publicationNumber"
              caption={t("PopupCategoriesPublicationNumber")!}
              headerCellRender={() =>
                headerCellWithOrderIcon(t("PopupCategoriesPublicationNumber")!)
              }
              visible={isVisible("PublicationNumber")}
              alignment={"left"}
              allowEditing={false}
            />
            <Column
              dataField="articleNumber"
              caption={t("PopupCategoriesArticleNumber")!}
              visible={true}
              headerCellRender={() =>
                headerCellWithOrderIcon(t("PopupCategoriesArticleNumber")!)
              }
              alignment={"left"}
              allowEditing={false}
            />
            <Column
              dataField="revisionDate"
              caption={t("PopupCategoriesRevisionDate")!}
              visible={false}
              dataType="date"
              format="dd/MM/yyyy"
              alignment={"center"}
              allowEditing={false}
            />
            <Column
              dataField="decisionDate"
              caption={t("PopupCategoriesDecisionDate")!}
              visible={false}
              dataType="date"
              format="dd/MM/yyyy"
              alignment={"center"}
              sortIndex={0}
              sortOrder="desc"
              allowEditing={false}
            />
            <Column
              dataField="referenceNumber"
              caption={t("PopupCategoriesReferenceNumber")!}
              headerCellRender={() =>
                headerCellWithOrderIcon(t("PopupCategoriesReferenceNumber")!)
              }
              visible={isVisible("ReferenceNumber")}
              alignment={"left"}
              allowEditing={false}
            />
            <Column
              dataField="source"
              caption={t("PopupCategoriesSource")!}
              headerCellRender={() =>
                headerCellWithOrderIcon(t("PopupCategoriesSource")!)
              }
              visible={isVisible("Source")}
              alignment={"left"}
              allowEditing={false}
            />
            <Column
              dataField="sourceExact"
              caption={t("PopupCategoriesSourceExact")!}
              visible={isVisible("SourceExact")}
              headerCellRender={() =>
                headerCellWithOrderIcon(t("PopupCategoriesSourceExact")!)
              }
              alignment={"left"}
              allowEditing={false}
            />
            <Column
              dataField="revisionNumber"
              caption={t("PopupCategoriesRevisionNumber")!}
              visible={false}
              alignment={"left"}
              allowEditing={false}
            />
            <Column
              dataField="docFormat"
              caption={t("DocFormat")!}
              visible={isVisible("DocFormat")}
              width={100}
              allowEditing={false}
            />
            <Column
              dataField="blobFilePath"
              visible={false}
              allowEditing={false}
            />
            <Column
              dataField="blobSecondFilePath"
              visible={false}
              allowEditing={false}
            />
            <Column dataField="isHtml" visible={false} allowEditing={false} />
            <Column
              dataField="htmlContent"
              visible={false}
              allowEditing={false}
            />
            <Column
              dataField="createdBy"
              visible={false}
              allowEditing={false}
            />
            <Column
              dataField="createdOn"
              visible={false}
              allowEditing={false}
            />

            <Column
              dataField="multiLanguage"
              caption={t("Language")!}
              visible={true}
              allowSorting={false}
              cellRender={(data) => <LanguageFlags data={data} />}
              alignment={"center"}
              allowEditing={false}
            />

            <Column type="buttons" caption={t("Actions")!} allowEditing={false}>
              <Button
                hint={t("FavoriteHint")!}
                icon="favorites"
                cssClass="favorite-button-treelist"
                onClick={handleSetDocAsFav}
                visible={isSettingFavoriteOptionVisible}
              />
              <Button
                hint={t("UnFavoriteHint")!}
                icon="favorites"
                cssClass="unfavorite-button-treelist"
                onClick={handleSetDocAsFav}
                visible={isSettingUnfavoriteOptionVisible}
              />
              <Button
                hint={t("HintCategoryDetails")!}
                icon="link"
                cssClass="favorite-button-treelist"
                onClick={onRedirectToCategoryDetails}
                visible={isRedirectOptionVisible}
              />
              <Button
                hint={t("HintDownload")!}
                icon="download"
                onClick={onDownloadFile}
                visible={isDownloadOptionVisible}
              />
              <Button
                hint={t("PopupCategoriesArticleLink")!}
                icon="link"
                cssClass="link-to-article-button-treelist "
                onClick={onRedirectToExternalLink}
                visible={isRedirectToExternalLinkVisible}
              />
            </Column>
          </TreeList>
        </Col>
      </Row>

      {/* PopupArea */}
      {/* PDF Popup */}
      {isModalOpen && (
        <ModalPDF
          setIsModalOpen={setIsModalOpen}
          documentReference={selectedDocument.reference}
          documentRevisionId={selectedDocumentRevisionId}
          categoryCode={selectedDocument.categoryCode}
          searchParam={
            searchGlobalKeyword && searchGlobalKeyword[0]
              ? searchGlobalKeyword[0]
              : "all"
          }
        />
      )}

      {/* HTML Popup */}
      <Popup
        id="seeHTMLDocPopupAllCategories"
        visible={HTMLDocumentPopupVisible}
        onHiding={closeHTMLPopup}
        dragEnabled={false}
        height={"90vh"}
        hideOnOutsideClick={true}
        showCloseButton={false}
        showTitle={true}
        title={selectedDocument.articleNumber!}
        container=".dx-viewport"
      >
        <Row>
          <Col>
            <DivCategoryPopup color={"#141b4d"}>
              <CategoryImage
                src={
                  "data:image/svg+xml;base64,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"
                }
              />
              <SpanCategory color={selectedCategory.color}>
                {t("HtmlPreview") + " - " + selectedDocument.articleNumber}
              </SpanCategory>
            </DivCategoryPopup>
          </Col>
        </Row>

        <ToolbarPopup
          widget="dxButton"
          toolbar="top"
          location="after"
          options={closeHTMLPopupButtonOptions}
        />
        <Row
          style={{
            marginBottom: "10px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Col md="auto">
            {selectedDocument && !selectedDocument.isSettingFavorite ? (
              <DivMultiLanguageInner>
                <ButtonPopupFavorite onClick={popupDocumentHandleFavorite}>
                  <FontAwesomeIcon icon={["far", "star"]} />
                  <ButtonText>{t("FavoriteHint")!}</ButtonText>
                </ButtonPopupFavorite>
              </DivMultiLanguageInner>
            ) : (
              <DivMultiLanguageInner>
                <ButtonPopupUnFavorite onClick={popupDocumentHandleFavorite}>
                  <FontAwesomeIcon icon={["fas", "star"]} />
                  <ButtonText>{t("UnFavoriteHint")!}</ButtonText>
                </ButtonPopupUnFavorite>
              </DivMultiLanguageInner>
            )}
          </Col>
          <Col md="auto">
            {selectedDocument && isPopupLinkToArticleOptionVisible() && (
              <DivMultiLanguageInner>
                <ButtonPopupFavorite onClick={handlePopupArticleLinkClick}>
                  <FontAwesomeIcon icon={["fas", "link"]} />
                  <ButtonText>{t("PopupCategoriesArticleLink")!}</ButtonText>
                </ButtonPopupFavorite>
              </DivMultiLanguageInner>
            )}
          </Col>
        </Row>
        <Row>
          <Col md="auto">
            {HTMLDocumentPopupVisible && (
              <div
                dangerouslySetInnerHTML={{
                  __html: selectedDocument.htmlContent,
                }}
              ></div>
            )}
          </Col>
        </Row>
      </Popup>
      {/* Documents Summary Popup */}
      <Popup
        id="documentsSummaryPopupAllCategories"
        visible={popupSummaryVisible}
        onHiding={hideSummaryPopup}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={false}
        showTitle={true}
        title={t("PopupDocumentsSummary")!}
        container=".dx-viewport"
      >
        <ToolbarPopup
          widget="dxButton"
          toolbar="top"
          location="after"
          options={closeSummaryPopupButtonOptions}
        />
        <Row>
          <Col>
            <DivCategoryPopup color={"#141b4d"}>
              <CategoryImage
                src={
                  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI3IDI3IiB2aWV3Qm94PSIwIDAgMjcgMjciPjxwYXRoIGQ9Ik0xNC43NCAyN0gyLjQ4Yy0uMTUgMC0uMjctLjEyLS4yNy0uMjdWNi42OGMwLS4wMiAwLS4wNC4wMS0uMDYuMDEtLjA0LjAzLS4wNy4wNi0uMUw4LjY3LjFjLjA2LS4wNy4xMy0uMS4yLS4xaDEyLjg3Yy4xNSAwIC4yNy4xMi4yNy4yN3YxMi4wMmMwIC4xNS0uMTIuMjctLjI3LjI3LS4xNSAwLS4yNy0uMTItLjI3LS4yN1YuNTRIOS4xNHY2LjE1YzAgLjE1LS4xMi4yNy0uMjcuMjdIMi43NXYxOS41aDExLjk5Yy4xNSAwIC4yNy4xMi4yNy4yN3MtLjEyLjI3LS4yNy4yN3pNMy4xMyA2LjQySDguNlYuOTJsLTUuNDcgNS41eiIvPjxwYXRoIGQ9Ik0xOS4zOSAyNi4yMmMtLjA4IDAtLjE0LS4wMS0uMi0uMDJsLTEuNi0uM2MtLjU0LS4xMS0uODktLjYzLS43OS0xLjE3bC4xMi0uNjRjLS4xNS0uMTItLjI5LS4yNC0uNDMtLjM3bC0uNjIuMjFjLS41NC4xOS0xLjEtLjEtMS4yNy0uNjFsLS41NC0xLjU1Yy0uMDktLjI1LS4wNy0uNTIuMDQtLjc2LjEyLS4yNC4zMi0uNDIuNTctLjUxbC42MS0uMjFjLjAxLS4xLjAzLS4xOS4wNS0uMjkuMDEtLjA5LjAzLS4xNy4wNi0uMjdsLS40OS0uNDNjLS40MS0uMzYtLjQ2LS45OS0uMTEtMS40MWwxLjA3LTEuMjVjLjE3LS4yLjQyLS4zMi42OC0uMzQuMjkgMCAuNTMuMDYuNzIuMjRsLjQ5LjQzYy4xNy0uMDguMzUtLjE0LjUzLS4xOGwuMTMtLjY1Yy4wNC0uMjYuMTktLjQ5LjQyLS42NC4yMS0uMTUuNDYtLjIxLjc0LS4xNmwxLjYyLjMxYy41NC4xMS44OS42My43OSAxLjE3bC0uMTIuNjRjLjE1LjEyLjI5LjI0LjQyLjM3bC42Mi0uMjFjLjUyLS4yIDEuMDkuMDkgMS4yNy42MWwuNTQgMS41NWEuOTk3Ljk5NyAwIDAgMS0uNjEgMS4yN2wtLjYxLjIyYy0uMDEuMDktLjAyLjE5LS4wNC4yOGwtLjA2LjI3LjQ5LjQzYy4yLjE4LjMyLjQzLjM0LjY5LjAyLjI2LS4wNy41Mi0uMjQuNzJsLTEuMDcgMS4yNWMtLjM2LjQxLTEgLjQ1LTEuNDEuMWwtLjQ5LS40M2MtLjE3LjA4LS4zNS4xNC0uNTMuMTlsLS4xMy42NGEuOTYuOTYgMCAwIDEtLjk2Ljgxem0tMi43NS0zLjEyLjEyLjEzYy4xOC4yLjM4LjM3LjYxLjUybC4xNC4xLS4xOS45OWMtLjA0LjI1LjEyLjQ5LjM3LjU0bDEuNjEuM2MuMjUuMDYuNDktLjEyLjUzLS4zNmwuMTktLjk5LjE3LS4wNGMuMjUtLjA2LjUxLS4xNS43NS0uMjZsLjE2LS4wOC43Ni42NWMuMDkuMDguMjEuMTIuMzMuMTEuMTItLjAxLjI0LS4wNi4zMS0uMTZsMS4wNy0xLjI1Yy4wOC0uMDkuMTItLjIxLjExLS4zM2EuNDUyLjQ1MiAwIDAgMC0uMTYtLjMybC0uNzYtLjY1LjA1LS4xN2MuMDQtLjEzLjA3LS4yNi4xLS4zOS4wMi0uMTMuMDQtLjI2LjA1LS40bC4wNC0uMTYuOTUtLjMzYS40NC40NCAwIDAgMCAuMjYtLjI0LjQ3LjQ3IDAgMCAwIC4wMi0uMzVsLS41NC0xLjU1YS40NjkuNDY5IDAgMCAwLS41OS0uMjhsLS45NS4zMy0uMTItLjEzYTMuNCAzLjQgMCAwIDAtLjYtLjUybC0uMTQtLjEuMTktLjk5YS40NzIuNDcyIDAgMCAwLS4zNy0uNTRsLTEuNjEtLjMxYy0uMTItLjAyLS4yNCAwLS4zNC4wOC0uMS4wNy0uMTcuMTctLjE5LjI5bC0uMTkuOTktLjE3LjA0Yy0uMjYuMDYtLjUxLjE1LS43NS4yNmwtLjE2LjA4LS43Ni0uNjZjLS4wOS0uMDgtLjIxLS4xNS0uMzMtLjExLS4xMi4wMS0uMjQuMDYtLjMxLjE2bC0xLjA3IDEuMjVjLS4xNi4xOS0uMTQuNDguMDUuNjRsLjc1LjY2LS4wNS4xNmMtLjA0LjEzLS4wNy4yNi0uMDkuMzktLjAzLjE0LS4wNS4yNy0uMDUuNGwtLjAxLjE3LS45NS4zM2MtLjEyLjA0LS4yMS4xMi0uMjYuMjMtLjA1LjExLS4wNi4yNC0uMDIuMzVsLjU0IDEuNTVjLjA4LjI0LjM1LjM2LjU5LjI4bC45MS0uMzF6bTIuNjguMjZjLS4xNSAwLS4zMS0uMDItLjQ3LS4wNGEyLjUyIDIuNTIgMCAwIDEtMi4wMS0yLjk2IDIuNTAyIDIuNTAyIDAgMCAxIDIuOTUtMi4wMWMuNjcuMTMgMS4yNC41IDEuNjEgMS4wNi4zOC41Ni41MiAxLjI0LjM5IDEuODlhMi40OTMgMi40OTMgMCAwIDEtMi40NyAyLjA2em0tLjAxLTQuNTFhMS45NjcgMS45NjcgMCAwIDAtMS45NCAxLjYyYy0uMS41Mi4wMSAxLjA1LjMxIDEuNDkuMy40My43NS43MyAxLjI3LjgzLjEyLjAyLjI1LjAzLjM3LjAzLjk2IDAgMS43Ny0uNjggMS45NS0xLjYxLjEtLjUyLS4wMS0xLjA1LS4zLTEuNDktLjMtLjQ0LS43NS0uNzMtMS4yNy0uODMtLjEzLS4wMy0uMjYtLjA0LS4zOS0uMDR6bS05LjM0IDEuNDNhLjg2NC44NjQgMCAwIDEtLjgxLS41OGwtLjExLS4zMi0uMTgtLjAzLS4yMy4yNmMtLjE1LjE3LS4zNS4yOC0uNTguMjktLjIzLjA0LS40NS0uMDYtLjYyLS4yMWwtLjg1LS43M2EuODc1Ljg3NSAwIDAgMS0uMDktMS4yMWwuMjMtLjI2YTMuMjUgMy4yNSAwIDAgMC0uMDYtLjE3bC0uMzMtLjA2YS44OS44OSAwIDAgMS0uNjktMS4wMWwuMjItMS4xMWMuMDQtLjIzLjE3LS40Mi4zNi0uNTVzLjQxLS4xOC42NC0uMTNsLjMzLjA2YS41LjUgMCAwIDEgLjA3LS4wOGMuMDEtLjAyLjAzLS4wNC4wNS0uMDZsLS4xMS0uMzJhLjg0NS44NDUgMCAwIDEgLjA0LS42NmMuMS0uMjEuMjctLjM2LjQ5LS40NGwxLjA2LS4zNmMuMjItLjA4LjQ1LS4wNS42Ni4wMy4yMS4xMS4zNy4yOS40NC41bC4xLjMyYy4wNi4wMS4xMy4wMi4xOC4wNGwuMjItLjI2Yy4xNS0uMTcuMzYtLjI4LjU5LS4yOS4yMy0uMDEuNDUuMDYuNjIuMmwuODUuNzRjLjE3LjE1LjI4LjM3LjI5LjZhLjgzLjgzIDAgMCAxLS4yMS42MWwtLjIyLjI2Yy4wMi4wNi4wNC4xMi4wNi4xN2wuMzMuMDdjLjIyLjA0LjQyLjE3LjU1LjM2LjEzLjE5LjE3LjQyLjE0LjY0bC0uMjIgMS4xYy0uMDQuMjMtLjE3LjQyLS4zNi41NS0uMTkuMTItLjQyLjE3LS42NS4xMmwtLjMyLS4wNmMtLjAyLjAzLS4wNC4wNS0uMDYuMDgtLjAyLjAyLS4wNC4wNC0uMDYuMDdsLjExLjMyYy4wNy4yMS4wNi40NS0uMDQuNjYtLjEuMi0uMjcuMzUtLjQ5LjQzbC0xLjA2LjM3Yy0uMS4wMy0uMTkuMDUtLjI4LjA1em0tMS4yOS0xLjU0LjE2LjA1Yy4xNC4wNC4yOC4wNy40Mi4wOGwuMTcuMDIuMjMuNjVjLjAyLjA4LjA4LjE1LjE1LjE4LjA4LjAzLjE3LjA0LjI1LjAybDEuMDYtLjM3Yy4wOS0uMDMuMTUtLjA4LjE4LS4xNi4wNC0uMDguMDQtLjE3LjAxLS4yNWwtLjIyLS42NC4xMy0uMTJjLjA1LS4wNS4xLS4xMS4xNS0uMTZsLjE0LS4xNy4xLS4xNC42Ni4xMmMuMDkuMDMuMTcuMDEuMjQtLjA0LjA3LS4wNS4xMi0uMTIuMTMtLjJsLjIyLTEuMWEuMzMuMzMgMCAwIDAtLjA1LS4yNC4zMTIuMzEyIDAgMCAwLS4yLS4xNGwtLjY3LS4xMy0uMDQtLjE3Yy0uMDMtLjE0LS4wOC0uMjgtLjE0LS40MWwtLjA3LS4xNi40NC0uNTFjLjA2LS4wNi4wOS0uMTUuMDgtLjIzIDAtLjA5LS4wNC0uMTctLjExLS4yM2wtLjg1LS43M2EuMzEuMzEgMCAwIDAtLjIzLS4wOGMtLjA5IDAtLjE2LjA0LS4yMS4xbC0uNDUuNTItLjE3LS4wNWEyLjcyIDIuNzIgMCAwIDAtLjQzLS4wOWwtLjE3LS4wMi0uMjItLjY0YS4zNS4zNSAwIDAgMC0uMTctLjE5LjQyLjQyIDAgMCAwLS4yNS0uMDFsLTEuMDUuMzdjLS4wOC4wMy0uMTQuMDktLjE4LjE2LS4wNC4wOC0uMDQuMTYtLjAyLjI0bC4yMi42NC0uMTMuMTJjLS4wNS4wNS0uMS4xLS4xNC4xNS0uMDYuMDYtLjEuMTItLjE0LjE4bC0uMS4xNC0uNjctLjEzYS4zMy4zMyAwIDAgMC0uMzguMjVsLS4yMSAxLjExYy0uMDMuMTcuMDkuMzQuMjYuMzhsLjY3LjEyLjA0LjE3Yy4wMy4xNC4wOC4yOC4xNC40MWwuMDguMTYtLjQ0LjUzYy0uMTEuMTMtLjEuMzMuMDQuNDVsLjg1LjczYy4wNi4wNi4xNy4wOC4yMy4wOC4wOS0uMDEuMTYtLjA0LjIxLS4xMWwuNDUtLjUxem0uODMtLjY5Yy0uNCAwLS43OC0uMTQtMS4wOS0uNC0uNjktLjYtLjc2LTEuNjYtLjE2LTIuMzQuNTktLjY4IDEuNjQtLjc2IDIuMzQtLjE3LjY5LjYuNzYgMS42NS4xNiAyLjM0LS4yOS4zNC0uNjkuNTQtMS4xNC41N2gtLjExem0wLTIuNzhjLS4zMSAwLS42Mi4xMy0uODUuMzktLjQuNDYtLjM1IDEuMTcuMTEgMS41OC4yMS4xNy40Ni4yNy43NC4yN2guMDhjLjMtLjAyLjU3LS4xNS43Ni0uMzguNC0uNDYuMzUtMS4xOC0uMTEtMS41OGExLjA4IDEuMDggMCAwIDAtLjczLS4yOHpNMTguMzcgOS45M0g1LjQyYy0uMTUgMC0uMjctLjEyLS4yNy0uMjcgMC0uMTUuMTItLjI3LjI3LS4yN2gxMi45NWMuMTUgMCAuMjcuMTIuMjcuMjcgMCAuMTUtLjEyLjI3LS4yNy4yN3oiLz48L3N2Zz4="
                }
              />
              <SpanCategory color={selectedCategory.color}>
                {t("AllCategoryDocuments")}
              </SpanCategory>
            </DivCategoryPopup>
          </Col>
        </Row>
        <DataGrid
          id="gridSummaryPopupAllCategories"
          dataSource={documentSummaries}
          keyExpr="documentRevisionId"
          showRowLines={true}
          showColumnLines={false}
          focusedRowEnabled={true}
          onRowClick={summaryPopupRowChanged}
          showBorders={true}
          noDataText={t("NoDataCategoryFiles")!}
          rowAlternationEnabled={true}
        >
          <PagingDataGrid defaultPageSize={10} />
          <SearchPanelDataGrid
            visible={true}
            width={240}
            placeholder={t("Search")!}
          />

          <ColumnDataGrid dataField="categoryDocumentId" visible={false} />

          <ColumnDataGrid dataField="categoryId" visible={false} />

          <ColumnDataGrid dataField="categoryCode" visible={false} />

          <ColumnDataGrid
            dataField="documentRevisionId"
            visible={false}
            width={10}
          />
          <ColumnDataGrid
            dataField="jurisdiction"
            caption={t("PopupCategoriesJurisdiction")!}
            visible={true}
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="resume"
            caption={t("PopupCategoriesResume")!}
            visible={isVisible("Resume")}
            width={400}
          />
          <ColumnDataGrid
            dataField="reference"
            caption={t("PopupCategoriesReference")!}
            visible={true}
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="status"
            caption={t("PopupCategoriesStatus")!}
            visible={isVisible("Status")}
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="number"
            caption={t("PopupCategoriesRevisionNumber")!}
            visible={false}
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="language"
            caption={t("Language")!}
            visible={false}
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="publicationTitle"
            caption={t("PopupCategoriesPublicationTitle")!}
            visible={isVisible("PublicationTitle")}
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="publicationNumber"
            caption={t("PopupCategoriesPublicationNumber")!}
            visible={isVisible("PublicationNumber")}
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="revisionDate"
            caption={t("PopupCategoriesRevisionDate")!}
            visible={true}
            dataType="date"
            format="dd/MM/yyyy"
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="decisionDate"
            caption={t("PopupCategoriesDecisionDate")!}
            visible={true}
            dataType="date"
            format="dd/MM/yyyy"
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="referenceNumber"
            caption={t("PopupCategoriesReferenceNumber")!}
            visible={isVisible("ReferenceNumber")}
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="source"
            caption={t("PopupCategoriesSource")!}
            visible={isVisible("Source")}
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="sourceExact"
            caption={t("PopupCategoriesSourceExact")!}
            visible={isVisible("SourceExact")}
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="revisionNumber"
            caption={t("PopupCategoriesRevisionNumber")!}
            visible={false}
            alignment={"center"}
          />
          <ColumnDataGrid
            dataField="articleNumber"
            caption={t("PopupCategoriesArticleNumber")!}
            visible={true}
            alignment={"center"}
          />
        </DataGrid>
      </Popup>

      {/* Multi Language Selection Popup */}
      <Popup
        id="multiLanguageSelectionPopupAllCategories"
        height={560}
        visible={multiLanguagePopupVisible}
        onHiding={hideMultiLanguagePopup}
        dragEnabled={false}
        hideOnOutsideClick={false}
        showCloseButton={false}
        showTitle={true}
        title={
          isTherePdfDocument(selectedDocument.multiLanguage)
            ? t("PopupMultiLanguage")!
            : t("PopupNoFiles")!
        }
        container=".dx-viewport"
      >
        <ToolbarPopup
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={closeMultiLanguagePopupButtonOptions}
        />
        <Row>
          <Col>
            <Form formData={selectedDocument} colCount={1}>
              <GroupItem colCount={1} visible={selectedDocument.resume}>
                <Item
                  dataField="resume"
                  editorType="dxTextArea"
                  editorOptions={resumeOptions}
                >
                  <Label>{t("PopupCategoriesResume")}</Label>
                </Item>
              </GroupItem>
            </Form>
          </Col>
          <Col md="auto">
            <DivMultiLanguage>
              <Row>
                <Col>
                  {isTherePdfDocument(selectedDocument.multiLanguage) ? (
                    <VersionsText>{t("AvailableLanguages")}:</VersionsText>
                  ) : null}
                </Col>
              </Row>

              <Row className="mt-2">
                {isTherePdfDocument(selectedDocument.multiLanguage) &&
                  selectedDocument.multiLanguage &&
                  selectedDocument.multiLanguage.map((a: any, idx: number) => (
                    <Col md="auto" key={idx}>
                      <DivMultiLanguageInner>
                        <span className="langContainer">
                          <LangSelector
                            selected={a.language}
                            onSelect={onSelectLanguage}
                            countries={["FR", "GB", "DE"]}
                            showSelectedLabel={false}
                            showOptionLabel={false}
                            fullWidth={false}
                            className="react-flags-popup-multi-language"
                            disabled
                          />
                        </span>
                        <ButtonMultiLanguage
                          onClick={() => onClickFlagButton(a)}
                          disabled={
                            !(
                              (selectedDocument.blobFileName &&
                                selectedDocument.blobFileName.includes(
                                  "pdf"
                                )) ||
                              (selectedDocument.blobSecondFileName &&
                                selectedDocument.blobSecondFileName.includes(
                                  "pdf"
                                ))
                            )
                          }
                        >
                          <FontAwesomeIcon icon={["fas", "eye"]} />
                          <ButtonText>
                            {a.language === "GB" ? "EN" : a.language}
                          </ButtonText>
                        </ButtonMultiLanguage>
                      </DivMultiLanguageInner>
                    </Col>
                  ))}
              </Row>

              <Row className="mt-2">
                <Col md="auto">
                  {selectedDocument && !selectedDocument.isSettingFavorite ? (
                    <DivMultiLanguageInner>
                      <ButtonPopupFavorite
                        onClick={popupDocumentHandleFavorite}
                      >
                        <FontAwesomeIcon icon={["far", "star"]} />
                        <ButtonText>{t("FavoriteHint")!}</ButtonText>
                      </ButtonPopupFavorite>
                    </DivMultiLanguageInner>
                  ) : (
                    <DivMultiLanguageInner>
                      <ButtonPopupUnFavorite
                        onClick={popupDocumentHandleFavorite}
                      >
                        <FontAwesomeIcon icon={["fas", "star"]} />
                        <ButtonText>{t("UnFavoriteHint")!}</ButtonText>
                      </ButtonPopupUnFavorite>
                    </DivMultiLanguageInner>
                  )}
                </Col>
              </Row>

              {selectedDocument && selectedDocument.articleLink && (
                <Row className="mt-2">
                  <Col md="auto">
                    <DivMultiLanguageInner>
                      <ButtonPopupLink
                        onClick={() =>
                          popupRedirectToExternalLink(
                            selectedDocument.articleLink
                          )
                        }
                      >
                        <FontAwesomeIcon icon={["fas", "link"]} />
                        <ButtonText>
                          {t("PopupCategoriesArticleLink")!}
                        </ButtonText>
                      </ButtonPopupLink>
                    </DivMultiLanguageInner>
                  </Col>
                </Row>
              )}

              {selectedDocument &&
                selectedDocument.blobSecondFileName !== null &&
                selectedDocument.blobSecondFileName !== "" &&
                selectedDocument.categoryCode === "models" && (
                  <Row className="mt-2">
                    <Col md="auto">
                      <DivMultiLanguageInner>
                        <ButtonPopupLink
                          onClick={() =>
                            downloadFile(selectedDocument.blobSecondFileName)
                          }
                        >
                          <FontAwesomeIcon icon={["fas", "download"]} />
                          <ButtonText>{t("DownloadWordTemplate")!}</ButtonText>
                        </ButtonPopupLink>
                      </DivMultiLanguageInner>
                    </Col>
                  </Row>
                )}
            </DivMultiLanguage>
          </Col>
        </Row>

        <Row className="pt-5">
          <Col>
            <DataGrid
              id="popupDocumentDetailsAllCategories"
              keyExpr="documentRevisionId"
              dataSource={[selectedDocument]}
              columnAutoWidth={true}
              showBorders={true}
            >
              <ColumnDataGrid
                dataField="documentRevisionId"
                allowEditing={false}
                visible={false}
              />
              <ColumnDataGrid
                dataField="searchGlobalKeyword"
                caption={t("SearchingKeyword")!}
                visible={
                  searchGlobalKeyword &&
                  searchGlobalKeyword[0] &&
                  searchGlobalKeyword[0] !== ""
                    ? true
                    : false
                }
                allowSorting={false}
                cellRender={(data) => <SearchSpan data={data} />}
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="summary"
                caption={t("Summary")!}
                visible={true}
                allowSorting={false}
                cellRender={(data) => <SummaryButtons data={data} />}
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="jurisdiction"
                caption={t("PopupCategoriesJurisdiction")!}
                visible={true}
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="reference"
                caption={t("PopupCategoriesReference")!}
                visible={true}
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="status"
                caption={t("PopupCategoriesStatus")!}
                visible={isVisible("Status")}
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="publicationTitle"
                caption={t("PopupCategoriesPublicationTitle")!}
                visible={isVisible("PublicationTitle")}
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="publicationNumber"
                caption={t("PopupCategoriesPublicationNumber")!}
                visible={isVisible("PublicationNumber")}
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="revisionDate"
                caption={t("PopupCategoriesRevisionDate")!}
                visible={true}
                dataType="date"
                format="dd/MM/yyyy"
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="decisionDate"
                caption={t("PopupCategoriesDecisionDate")!}
                visible={true}
                dataType="date"
                format="dd/MM/yyyy"
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="referenceNumber"
                caption={t("PopupCategoriesReferenceNumber")!}
                visible={isVisible("ReferenceNumber")}
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="source"
                caption={t("PopupCategoriesSource")!}
                visible={isVisible("Source")}
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="sourceExact"
                caption={t("PopupCategoriesSourceExact")!}
                visible={isVisible("SourceExact")}
                alignment={"center"}
              />
              <ColumnDataGrid
                dataField="articleNumber"
                caption={t("PopupCategoriesArticleNumber")!}
                visible={true}
                alignment={"center"}
              />

              <ColumnDataGrid
                dataField="multiLanguage"
                caption={t("Language")!}
                visible={true}
                allowSorting={false}
                cellRender={(data) => <LanguageFlags data={data} />}
                alignment={"center"}
              />
            </DataGrid>
          </Col>
        </Row>
      </Popup>

      {/* Summary Filtering Popup */}
      <Popup
        id="summaryFilterPopup"
        visible={popupFilterSummaryVisible}
        onHiding={hideFilterSummaryPopup}
        dragEnabled={false}
        hideOnOutsideClick={false}
        showCloseButton={false}
        showTitle={true}
        title={t("PopupCategoriesSummary")!}
        container=".dx-viewport"
      >
        <ToolbarPopup
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={closeSummaryPopupFilterButtonOptions}
        />
        <ToolbarPopup
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={saveSummaryPopupFilterButtonOptions}
        />
        <ToolbarPopup
          toolbar="top"
          location="after"
          widget="dxButton"
          options={clearSelectionOptions}
        />
        <DataGrid
          id="gridSummaryPopup"
          dataSource={summaries}
          showRowLines={true}
          showColumnLines={false}
          onSelectionChanged={onSummarySelectionChanged}
          noDataText={t("DashboardSummaryNoResults")!}
          showBorders={true}
          rowAlternationEnabled={true}
          ref={(ref) => {
            summaryDataGrid = ref;
          }}
        >
          <PagingDataGrid defaultPageSize={10} />
          <HeaderFilterDataGrid visible={true} />
          <SearchPanelDataGrid
            visible={true}
            width={240}
            placeholder={t("Search")!}
          />
          <SelectionDataGrid
            mode="multiple"
            selectAllMode="allPages"
            showCheckBoxesMode="onClick"
          />
          <ColumnDataGrid
            dataField="id"
            width={40}
            allowEditing={false}
            allowHeaderFiltering={false}
          />
          <ColumnDataGrid dataField="name">
            <HeaderFilterDataGrid dataSource={nameHeaderFilterDataSource} />
          </ColumnDataGrid>
          <ColumnDataGrid
            dataField="createdBy"
            caption={t("CreatedBy")!}
            allowEditing={false}
            alignment={"center"}
            allowHeaderFiltering={false}
            visible={isUserAdmin()}
          />
          <ColumnDataGrid
            dataField="createdOn"
            dataType="date"
            format="dd/MM/yyyy"
            caption={t("CreatedOn")!}
            alignment={"center"}
            allowEditing={false}
            allowHeaderFiltering={false}
            visible={isUserAdmin()}
          />
          <ColumnDataGrid
            dataField="updatedBy"
            caption={t("UpdatedBy")!}
            allowEditing={false}
            alignment={"center"}
            allowHeaderFiltering={false}
            visible={isUserAdmin()}
          />
          <ColumnDataGrid
            dataField="updatedOn"
            dataType="date"
            alignment={"center"}
            allowEditing={false}
            format="dd/MM/yyyy"
            caption={t("UpdatedOn")!}
            allowHeaderFiltering={false}
            visible={isUserAdmin()}
          />
        </DataGrid>
        <div className="selected-data pt-2">
          <span className="caption">
            {t("PopupCategoriesSummaryTotalSelection") +
              " (" +
              selectedSummaries.length +
              ") " +
              ": "}{" "}
          </span>

          {selectedSummaries.length ? (
            selectedSummaries.map((a: any, id: number) => (
              <span className="p-1" key={id}>
                <Badge bg="info" style={{ fontSize: 12 }}>
                  {a.name}
                </Badge>
              </span>
            ))
          ) : (
            <Badge bg="info" style={{ fontSize: 12 }}>
              {t("PopupCategoriesSummaryNoSelection")}
            </Badge>
          )}
        </div>
      </Popup>

      {/* Category Filtering Popup */}
      <Popup
        id="categoryFilterPopup"
        visible={popupFilterCategoryVisible}
        onHiding={hideFilterCategoryPopup}
        dragEnabled={false}
        hideOnOutsideClick={false}
        showCloseButton={false}
        showTitle={true}
        title={t("PopupCategoriesCategory")!}
        container=".dx-viewport"
      >
        <ToolbarPopup
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={closeCategoryPopupFilterButtonOptions}
        />
        <ToolbarPopup
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={saveCategoryPopupFilterButtonOptions}
        />
        <ToolbarPopup
          toolbar="top"
          location="after"
          widget="dxButton"
          options={clearCategorySelectionOptions}
        />
        <DataGrid
          id="gridCategoryPopup"
          dataSource={categories}
          showRowLines={true}
          showColumnLines={false}
          onSelectionChanged={onCategorySelectionChanged}
          noDataText={t("DashboardSummaryNoResults")!}
          showBorders={true}
          rowAlternationEnabled={true}
          ref={(ref) => {
            categoryDataGrid = ref;
          }}
        >
          <PagingDataGrid defaultPageSize={10} />
          <SearchPanelDataGrid
            visible={true}
            width={240}
            placeholder={t("Search")!}
          />
          <SelectionDataGrid
            mode="multiple"
            selectAllMode="allPages"
            showCheckBoxesMode="onClick"
          />
          <ColumnDataGrid
            dataField="id"
            width={40}
            allowEditing={false}
            allowHeaderFiltering={false}
          />
          <ColumnDataGrid dataField="name" />
        </DataGrid>
        <div className="selected-data pt-2">
          <span className="caption">
            {t("PopupCategoriesSummaryTotalSelection") +
              " (" +
              selectedCategories.length +
              ") " +
              ": "}{" "}
          </span>

          {selectedCategories.length ? (
            selectedCategories.map((a: any, id: number) => (
              <span className="p-1" key={id}>
                <Badge bg="info" style={{ fontSize: 12 }}>
                  {a.name}
                </Badge>
              </span>
            ))
          ) : (
            <Badge bg="info" style={{ fontSize: 12 }}>
              {t("PopupCategoriesCategoryNoSelection")}
            </Badge>
          )}
        </div>
      </Popup>

      {/* End of PopupArea */}
    </TreeListContainer>
  );
}

export default GlobalSearchTreeList;
